import React from 'react';
import styled from 'styled-components';

const p = styled.div`
    color: ${props => !props.invertedColors ? props.theme.colors.primaryText : props.theme.colors.primaryTextInverted};
    padding-bottom: ${props => !props.preventPadding ? '1rem' : '0'};
    padding-top: ${props => !props.preventPadding ? '1rem' : '0'};
`;

export default p;

